import NavBar from "../components/NavBar";
import SideBar from "../components/SideBar";
import SideBarMovil from "../components/SideBarMovile";
import Container from "../components/Container";
import "../components/styles/MapBox.css";
import Perfil from "../sections/Perfil";
import Admin from "../sections/Admin";
import Cis from "../sections/Cis";
import Hosts from "../sections/Hosts";
import Buzon from "../sections/Buzon";
import Reportes from "../sections/Reportes";
import Monitoreo from "../sections/Monitoreo";
import Modal from "react-modal";
import ModalVerificateUser from "../components/main-components/ModalVerificateUser";
import Portafolio from "../sections/Portafolio";
import Excepciones from "../sections/Excepciones";
import { useState, useEffect, Component } from "react";
import { useFetch } from "../hooks/useFetch";
import Acciones from "../sections/Acciones";
import { Redirect } from "react-router-dom";
import Popup from "../components/generales/Popup";
import "../sections/styles/perfil.css";
import Config from "../sections/Config";
import Encuestas from "../sections/Encuestas";
import WorkFlow from "../sections/WorkFlow";
import { lang } from "../components/generales/traduction";
import { capitalizeFirstLetter } from "../utils/utils";
import Respaldo from "../sections/Respaldo";
import Provisionamiento from "../sections/Provisionamiento";
import MainMonitoreo from "../sections/MainMonitoreo";

import AppProvider from "../context/AppProvider";

const verificateUserModalStyles = {
    content: {
        top: "50%",
        left: "50%",
        background: "#ffffff !important",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        width: "40%",
        height: "70%",
        padding: "20px",
    },
};
const Main = ({
    onLogin,
    setMsgErrorLogin,
    token,
    setToken,
    server,
    setServer,
    object_state_sessions,
    set_object_state_sessions,
}) => {


    const [pageSelected, setPageSelected] = useState("inicio");
    const [rol_id, setRolID] = useState("");
    const [dataPermisos, setDataPermisos] = useState({
        data: [],
        loading: true,
        error: "",
    });
    const [userPermissions, setUserPermissions] = useState([]);
    const [mode, setMode] = useState("");
    const [languaje, setLanguaje] = useState('es');
    const [titleHead, setTitleHead] = useState(lang[languaje]['inicio'])
    // console.log(userPermissions)
    const getPermisos = (rol_id) => {

        setDataPermisos({ data: dataPermisos.data, loading: true, error: "" });
        const fetchDataPost = async () => {
            try {

                const response = await fetch(
                    server.url +
                    "/api/v1/cassia/users/roles/" +
                    rol_id,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    }
                );

                if (response.ok) {
                    const data1 = await response.json();

                    setUserPermissions(data1.data.permissions);
                    setDataPermisos({ data: data1, loading: false, error: "" });
                } else {
                    throw new Error("Error en la solicitud");
                }
            } catch (error) {
                setDataPermisos({ data: dataPermisos.data, loading: false, error: "" });

            }
        };

        fetchDataPost();
    };

    const [verificateUserModalOpen, setVerificateUserModalOpen] = useState(false);
    const [nameState, setNameState] = useState("");
    const [estadoActivo, setEstadoActivo] = useState({});
    const [estadoSelected, setEstadoSelected] = useState({});
    const [dataPingEstado, setDataPingEstado] = useState({
        data: [],
        loading: false,
        error: "",
    });

    const [globals, setGlobals] = useState({
        data: [],
        loading: false,
        error: "",
    });

    const estados_list = useFetch(
        "cassia/configuration/estados",
        "",
        "",
        "GET",
        server
    );
    const [newLogin, setNewLogin] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [infoPopup, setInfoPopup] = useState({
        message: "",
        title: "",
        submsg: "",
        type: false,
    });
    const [serverStatus, setServerStatus] = useState(false);
    const [statusChangeState, setStatusChangeState] = useState(false);
    const [statusLoginState, setStatusLoginState] = useState(true);
    const [statusObjectStates, setStatusObjectStates] = useState(false);
    const [msgCharge, setMsgCharge] = useState("");
    const handleShowPopup = (title, message, submsg, type) => {
        setInfoPopup({
            message: message,
            title: title,
            submsg: submsg,
            type: type,
        });
        setShowPopup(true);
        setTimeout(() => {
            setShowPopup(false);
        }, 10000);
    };
    const idEstadoExistente = (id) => {
        return Object.values(object_state_sessions).some(
            (estado) => estado.id === id
        );
    };

    useEffect(() => {
        if (serverStatus) {
            if (!idEstadoExistente(estadoSelected.id)) {

                login_state();
            } else {

                getDataGlobals();
            }
        } else {
            setServerStatus(true);
        }
    }, [server]);

    useEffect(() => {
        if (localStorage.getItem("object_state_sessions") != 1) {
            getDataGlobals();
        }

        if (Object.values(object_state_sessions).length != 0) {

            localStorage.setItem(
                "object_state_sessions",
                JSON.stringify(object_state_sessions)
            );
        }
    }, [object_state_sessions]);
    function getDataGlobals() {
        var object_state = "";
        var token_state = "";

        if (
            Object.values(object_state_sessions).length != 0 &&
            Object.values(estadoActivo).length != 0
        ) {
            if (Object.values(object_state_sessions).length > 0) {
                var id_state = 0;
                if (Object.values(estadoSelected) == 0) {
                    id_state = estadoActivo.id;
                } else {
                    id_state = estadoSelected.id;
                }
                object_state = Object.values(object_state_sessions).find(
                    (obj) => obj.id === id_state
                );
                token_state = object_state.access_token;
            }
        } else {
            token_state = localStorage.getItem("access_token");
        }

        setGlobals({ data: globals.data, loading: true, error: globals.error });
        const fetchData = async () => {
            try {
                const response = await fetch(
                    server.url +
                    "/api/v1/cassia/configuration",
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token_state}`,

                        },
                    }
                );

                if (response.ok) {
                    const response_data = await response.json();

                    setGlobals({ data: response_data, loading: false, error: false });
                    localStorage.setItem("access_token", token_state);

                    setEstadoActivo(estadoSelected);
                    setEstadoSelected({});

                } else {

                    setGlobals({ data: globals.data, loading: false, error: true });
                    throw new Error("Error en la solicitud");
                }
            } catch (error) {

                setGlobals({ data: globals.data, loading: false, error: true });

            }
        };
        fetchData();
    }
    useEffect(() => {
        if (estadoSelected.id != estadoActivo.id) {
            if (!idEstadoExistente(estadoSelected.id)) {

                if (Object.keys(estadoSelected).length !== 0) {
                    ping_estado(estadoSelected.id);
                }
            } else {
                const object_state = Object.values(object_state_sessions).find(
                    (obj) => obj.id == estadoSelected.id
                );

                setServer({ ip: object_state.server, port: object_state.port });
                localStorage.setItem("access_token", object_state.access_token);
            }
        }
    }, [estadoSelected]);

    useEffect(() => {

        if (dataPingEstado.data != undefined) {
            if (dataPingEstado.data.available) {
                const ipPattern = /\b(?:\d{1,3}\.){3}\d{1,3}\b/;
                const match = estadoSelected.url.match(ipPattern);

                if (match) {
                    const ipAddress = match[0];
                    setServer({ ip: ipAddress, port: server.port });
                }

            } else {
                // console.log("no hizo ping");
                // console.log(dataPingEstado.error)
            }
        }

    }, [dataPingEstado.data]);

    const login_state = async (e) => {
        setMsgCharge(capitalizeFirstLetter(lang[languaje]['iniciandoSession']) + "...");

        setDataPingEstado({
            data: dataPingEstado.data,
            loading: true,
            error: dataPingEstado.error,
        });
        const formData = new URLSearchParams();
        var server_url = "";
        var port_url = "";
        var user_log = "";
        var pass_log = "";
        if (!localStorage.getItem("aux_server_ip")) {
            user_log = localStorage.getItem("user_cassia");
            pass_log = localStorage.getItem(
                "password_cassia_" + localStorage.getItem("main_access_token")
            );
            server_url = server.ip;
            port_url = server.port;
            formData.append("username", localStorage.getItem("user_cassia"));
            formData.append(
                "password",
                localStorage.getItem(
                    "password_cassia_" + localStorage.getItem("main_access_token")
                )
            );
        } else {
            server_url = localStorage.getItem("aux_server_ip");
            port_url = 8000; //localStorage.getItem('aux_server_port')
            user_log = localStorage.getItem("aux_user_cassia");
            pass_log = localStorage.getItem("aux_pass_cassia");
            formData.append("username", user_log);
            formData.append("password", pass_log);

        }
        formData.append("grant_type", "");
        formData.append("scope", "");
        formData.append("client_id", "");
        formData.append("client_secret", "");
        localStorage.removeItem("aux_server_ip");
        localStorage.removeItem("aux_server_ip");

        try {

            const response = await fetch(
                server.url + "/api/v1/auth/login",
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    body: formData,
                }
            );

            if (response.ok) {
                const data = await response.json();

                setNewLogin(true);
                setStatusChangeState(false);
                setStatusLoginState(true);
                if (!idEstadoExistente(estadoSelected.id)) {
                    set_object_state_sessions((prevObj) => ({
                        ...prevObj,
                        [Object.keys(prevObj).length]: {
                            id: estadoSelected.id,
                            name: estadoSelected.name,
                            server: server_url,
                            port: port_url,
                            user: user_log,
                            pass: pass_log,
                            access_token: data.data.access_token,
                        },
                    }));
                }
            } else {
                setEstadoSelected({});
                // setUserVal(false)
                throw new Error("Error en la solicitud");
            }
        } catch (error) {
            setEstadoSelected({});
            // setError(error)
            setServerStatus(false);
            localStorage.setItem("aux_server_ip", server.ip);
            localStorage.setItem("aux_server_port", server.port);
            setServer({
                ip: localStorage.getItem("main_server_ip"),
                port: localStorage.getItem("main_server_port"),
            });
            setMsgCharge(capitalizeFirstLetter(lang[languaje]["credencialesNoAceptadas"]));

            setStatusLoginState(false);
            setDataPingEstado({
                data: dataPingEstado.data,
                loading: false,
                error: dataPingEstado.error,
            });
        }
    };
    useEffect(() => {
        try {
            let userSession = JSON.parse(localStorage.getItem("user_session"));

            const expirationDate = new Date(userSession.refresh_token_expires);
            const currentDate = new Date();

            getPermisos(userSession.roles[0].rol_id);
            setRolID(userSession.roles[0].rol_id);
            if (userSession.verified_at === null) {
                setVerificateUserModalOpen(true);
            } else {
                setVerificateUserModalOpen(false);
                if (expirationDate < currentDate) {
                    onLogin(false);
                }
            }
        } catch (error) {

            onLogin(false);
            localStorage.setItem(
                "MsgErrorLogin",
                capitalizeFirstLetter(lang[languaje]['msgUserErrorData'])
            );
            localStorage.setItem("ErrorLogin", true);
            setMsgErrorLogin(
                capitalizeFirstLetter(lang[languaje]['msgUserErrorData'])
            );
        }
    }, []);

    function closVerificateUserModal() {
        setVerificateUserModalOpen(false);
    }

    function ping_estado(id_estado) {

        setNewLogin(false);
        setMsgCharge(capitalizeFirstLetter(lang[languaje]['pingServer']) + "...");
        setStatusChangeState(true);

        setDataPingEstado({
            data: dataPingEstado.data,
            loading: true,
            error: dataPingEstado.error,
        });
        const fetchData = async () => {
            try {

                const response = await fetch(
                    "http://" +
                    localStorage.getItem("main_server_ip") +
                    ":" +
                    localStorage.getItem("main_server_port") +
                    "/api/v1/cassia/configuration/estados/ping/" +
                    id_estado,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem(
                                "main_access_token"
                            )}`,
                        },
                    }
                );

                if (response.ok) {
                    const response_data = await response.json();

                    setDataPingEstado({
                        data: response_data.data,
                        loading: false,
                        error: response_data.message,
                    });
                } else {
                    setEstadoSelected({});
                    throw new Error("Error en la solicitud");
                }
            } catch (error) {
                setEstadoSelected({});

            }
        };
        fetchData();
    }
    return (
        <div
            className="main"
            style={{ height: "100%", width: "100%", position: "absolute" }}
        >
            <AppProvider
                userPermissions={userPermissions}
                alertFunctions={{
                    handleShowPopup,
                    showPopup,
                    setShowPopup,
                    infoPopup,
                    setInfoPopup
                }}
            >
                <>
                    <NavBar
                        setServer={setServer}
                        login_state={login_state}
                        setStatusLoginState={setStatusLoginState}
                        statusLoginState={statusLoginState}
                        dataGlobals={globals.data.data}
                        loadGlobals={globals.loading}
                        msgCharge={msgCharge}
                        statusChangeState={statusChangeState}
                        setStatusChangeState={setStatusChangeState}
                        server={server}
                        object_state_sessions={object_state_sessions}
                        set_object_state_sessions={set_object_state_sessions}
                        estadoActivo={estadoActivo}
                        setEstadoActivo={setEstadoActivo}
                        estados_list={estados_list}
                        nameState={nameState}
                        estadoSelected={estadoSelected}
                        setEstadoSelected={setEstadoSelected}
                        dataPingEstado={dataPingEstado}
                        languaje={languaje}
                        pageSelected={pageSelected}
                    />
                    {/* <SideBar
          mode={mode}
          dataGlobals={globals}
          userPermissions={userPermissions}
          rolId={rol_id}
          onLogin={onLogin}
          pageSelected={pageSelected}
          setPageSelected={setPageSelected}
          languaje={languaje}
          titleHead={titleHead}
          setTitleHead={setTitleHead}
        /> */}
                    <SideBarMovil
                        mode={mode}
                        dataGlobals={globals}
                        userPermissions={userPermissions}
                        rolId={rol_id}
                        onLogin={onLogin}
                        pageSelected={pageSelected}
                        setPageSelected={setPageSelected}
                        languaje={languaje}
                        titleHead={titleHead}
                        setTitleHead={setTitleHead}
                    />
                    <Container mode={mode} languaje={languaje}>
                        {(() => {
                            if (globals.loading) {
                                return (
                                    <>
                                        <div className="top-welcome">
                                            <div className="TitleHead" style={{ display: "flex", justifyContent: 'center', alignItems: 'center' }}>
                                                <img
                                                    src="SaimonTech_logo.png"
                                                    style={{ width: "35%" }}
                                                    alt="Logo"
                                                />
                                            </div>
                                        </div>
                                        <div className="mid-welcome">
                                            {
                                                <div className="cont-load-main">
                                                    <div className="txt-load-main">
                                                        {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])}...
                                                    </div>
                                                    <section className="dots-container-main">
                                                        <div className="dots-main"></div>
                                                        <div className="dots-main"></div>
                                                        <div className="dots-main"></div>
                                                        <div className="dots-main"></div>
                                                        <div className="dots-main"></div>
                                                    </section>
                                                </div>
                                            }
                                        </div>
                                    </>
                                );
                            } else {
                                if (globals.error) {
                                    return (
                                        <>
                                            <div className="top-welcome">
                                                <div className="TitleHead" style={{ display: "flex", justifyContent: 'center', alignItems: 'center' }}>
                                                    <img
                                                        src="logo_cassiaWhite.png"
                                                        style={{ width: "50%" }}
                                                        alt="Logo"
                                                    />
                                                </div>
                                            </div>
                                            <div className="mid-welcome" style={{ display: "block" }}>
                                                {
                                                    <>
                                                        <div
                                                            className="cont-load-main"
                                                            style={{ height: "50%" }}
                                                        >
                                                            <div
                                                                className="txt-load-main"
                                                                style={{ animation: "unset", color: "red" }}
                                                            >
                                                                {capitalizeFirstLetter(lang[languaje]['CargandoDatosError'])}!!!
                                                            </div>
                                                        </div>
                                                        <div
                                                            className="cont-load-main"
                                                            style={{ height: "50%" }}
                                                        >
                                                            <div
                                                                className="txt-load-main"
                                                                style={{ animation: "unset", color: "#15243E" }}
                                                            >
                                                                {capitalizeFirstLetter(lang[languaje]['msgCerrarsession'])}.
                                                            </div>
                                                        </div>
                                                        <div
                                                            className="cont-load-main"
                                                            style={{ justifyContent: "center", alignItems: 'center' }}
                                                        >
                                                            <div
                                                                className="sidebarCont  btnLogout"
                                                                style={{
                                                                    width: "10%",
                                                                    height: "30%",
                                                                    border: "2px solid red",
                                                                    borderRadius: "10px",
                                                                }}
                                                                onClick={onLogin}
                                                            >
                                                                <div className="imgSideCont">
                                                                    <img src="/iconos/log-out-red.svg" />
                                                                </div>
                                                                <div className="" style={{ color: "#15243E" }}>
                                                                    {capitalizeFirstLetter(lang[languaje]['salir'])}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                        </>
                                    );
                                } else {
                                    if (pageSelected === "inicio") {
                                        return (
                                            <Perfil
                                                mode={mode}
                                                setMode={setMode}
                                                server={server}
                                                userPermissions={userPermissions}
                                                dataGlobals={globals}
                                                setNameState={setNameState}
                                                languaje={languaje}
                                                setLanguaje={setLanguaje}
                                            />
                                        );
                                    } else if (pageSelected === "monitoreo" || pageSelected === "monitor-mapa" || pageSelected === "monitor-mapa-afiliation" || pageSelected === "monitor-eventos" || pageSelected === "monitor-indicadores" || pageSelected === "monitor-grupos" || pageSelected === "monitor-resets") {
                                        return (
                                            // <Monitoreo
                                            //   mode={mode}
                                            //   estados_list={estados_list}
                                            //   userPermissions={userPermissions}
                                            //   handleShowPopup={handleShowPopup}
                                            //   server={server}
                                            //   token={token}
                                            //   dataGlobals={globals.data.data}
                                            //   estadoSelected={estadoSelected}
                                            //   setEstadoSelected={setEstadoSelected}
                                            //   languaje={languaje}
                                            // />
                                            <MainMonitoreo
                                                mode={mode}
                                                estados_list={estados_list}
                                                userPermissions={userPermissions}
                                                handleShowPopup={handleShowPopup}
                                                server={server}
                                                token={token}
                                                dataGlobals={globals.data.data}
                                                estadoSelected={estadoSelected}
                                                setEstadoSelected={setEstadoSelected}
                                                pageSelected={pageSelected}
                                                languaje={languaje}
                                                globals={globals}
                                            />
                                        );
                                    } else if (pageSelected === "admin-users" || pageSelected === "admin-rol" || pageSelected === "noti-user" || pageSelected === "noti-tec" || pageSelected === "admin-grupos") {
                                        return (
                                            <Admin
                                                server={server}
                                                userPermissions={userPermissions}
                                                dataGlobals={globals.data.data}
                                                languaje={languaje}
                                                mode={mode}
                                                pageSelected={pageSelected}
                                                handleShowPopup={handleShowPopup}
                                            />
                                        );
                                    } else if (pageSelected === "cis") {
                                        return (
                                            <Cis
                                                server={server}
                                                userPermissions={userPermissions}
                                                dataGlobals={globals.data.data}
                                                languaje={languaje}
                                                mode={mode}
                                                handleShowPopup={handleShowPopup}

                                                estados_list={estados_list}

                                                token={token}
                                                estadoSelected={estadoSelected}
                                                setEstadoSelected={setEstadoSelected}
                                                pageSelected={pageSelected}
                                                globals={globals}
                                            />
                                        );
                                    } else if (pageSelected === "portafolio") {
                                        return (
                                            <Portafolio
                                                server={server}
                                                userPermissions={userPermissions}
                                                dataGlobals={globals.data.data}
                                                languaje={languaje}
                                                mode={mode}
                                                handleShowPopup={handleShowPopup}

                                                estados_list={estados_list}
                                                token={token}
                                                estadoSelected={estadoSelected}
                                                setEstadoSelected={setEstadoSelected}
                                                pageSelected={pageSelected}
                                                globals={globals}
                                            />
                                        );
                                    } else if (pageSelected === "mantenimiento" || pageSelected === "mantto-excepciones" || pageSelected === "mantto-calendar") {
                                        return (
                                            <Excepciones
                                                server={server}
                                                userPermissions={userPermissions}
                                                dataGlobals={globals.data.data}
                                                languaje={languaje}
                                                mode={mode}
                                                pageSelected={pageSelected}
                                                handleShowPopup={handleShowPopup}
                                            />
                                        );
                                    } else if (pageSelected === "reporte-disp" || pageSelected === "reporte-historicDisp" || pageSelected === "reporte-disp-host" || pageSelected === "reporte-met" || pageSelected === "reporte-met-host"
                                        || pageSelected === "reporte-eventos-historic" || pageSelected === "reporte-eventos-tickets" || pageSelected === "reporte-BI"
                                        || pageSelected === "reporte-graph-metrica" || pageSelected === "reporte-graph-kpi" || pageSelected === "reporte-kpi"
                                    ) {
                                        return (
                                            <Reportes
                                                server={server}
                                                userPermissions={userPermissions}
                                                dataGlobals={globals.data.data}
                                                languaje={languaje}
                                                mode={mode}
                                                pageSelected={pageSelected}
                                                handleShowPopup={handleShowPopup}
                                            />
                                        );
                                    } else if (pageSelected === "acciones") {
                                        return (
                                            <Acciones
                                                server={server}
                                                userPermissions={userPermissions}
                                                dataGlobals={globals.data.data}
                                                languaje={languaje}
                                                mode={mode}
                                            />
                                        );
                                    } else if (pageSelected === "host-manage") {
                                        return (
                                            <Hosts
                                                server={server}
                                                userPermissions={userPermissions}
                                                dataGlobals={globals.data.data}
                                                languaje={languaje}
                                                mode={mode}
                                            />
                                        );
                                    } else if (pageSelected === "buzon") {
                                        return (
                                            <Buzon
                                                server={server}
                                                userPermissions={userPermissions}
                                                dataGlobals={globals.data.data}
                                                languaje={languaje}
                                                mode={mode}
                                                handleShowPopup={handleShowPopup}
                                            />
                                        );
                                    } else if (pageSelected === "respaldo-config") {
                                        return (
                                            <Respaldo
                                                server={server}
                                                userPermissions={userPermissions}
                                                dataGlobals={globals.data.data}
                                                languaje={languaje}
                                                mode={mode}
                                                pageSelected={pageSelected}
                                                handleShowPopup={handleShowPopup}
                                            />
                                        );
                                    } else if (pageSelected === "provicionamiento-config" || pageSelected === "provicionamiento-soft" || pageSelected === "provicionamiento-auditor" || pageSelected === "provicionamiento-calendario") {
                                        return (
                                            <Provisionamiento
                                                server={server}
                                                userPermissions={userPermissions}
                                                dataGlobals={globals.data.data}
                                                languaje={languaje}
                                                mode={mode}
                                                pageSelected={pageSelected}
                                                handleShowPopup={handleShowPopup}
                                            />
                                        );
                                    }
                                    else if (pageSelected === "config-Cis" || pageSelected === "config-agency" || pageSelected === "config-criticity" || pageSelected === "config-grupos"
                                        || pageSelected === "config-proxies" || pageSelected === "config-tec" || pageSelected === "config-brand"
                                        || pageSelected === "config-models" || pageSelected === "config-hosts" || pageSelected === "config-audit"
                                        || pageSelected === "config-telegram" || pageSelected === "config-platelegram" || pageSelected === "config-lastReadTele"
                                        || pageSelected === "config-mediciones" || pageSelected === "config-disparadores" || pageSelected === "config-eventos"
                                        || pageSelected === "config-correlacion"

                                    ) {
                                        return (
                                            <Config
                                                server={server}
                                                userPermissions={userPermissions}
                                                dataGlobals={globals.data.data}
                                                languaje={languaje}
                                                mode={mode}
                                                pageSelected={pageSelected}
                                                handleShowPopup={handleShowPopup}
                                            />
                                        );
                                    }
                                    else if (pageSelected === "encuestas-gen" || pageSelected === "encuestas-res"

                                    ) {
                                        return (
                                            <Encuestas
                                                server={server}
                                                userPermissions={userPermissions}
                                                dataGlobals={globals.data.data}
                                                languaje={languaje}
                                                mode={mode}
                                                pageSelected={pageSelected}
                                                handleShowPopup={handleShowPopup}
                                            />
                                        );
                                    }
                                    else if (pageSelected === "workflow-gen" || pageSelected === "workflow-action"
                                    ) {
                                        return (
                                            <WorkFlow
                                                server={server}
                                                userPermissions={userPermissions}
                                                dataGlobals={globals.data.data}
                                                languaje={languaje}
                                                mode={mode}
                                                pageSelected={pageSelected}
                                                handleShowPopup={handleShowPopup}
                                            />
                                        );
                                    }
                                }
                            }
                        })()}
                        <Popup
                            infoPopup={infoPopup}
                            isVisible={showPopup}
                            setShowPopup={setShowPopup}
                            setInfoPopup={setInfoPopup}
                            languaje={languaje}
                        ></Popup>
                    </Container>
                </>
                <Modal
                    isOpen={verificateUserModalOpen}
                    // isOpen={false}
                    // onAfterOpen={afterOpenExeption}
                    onRequestClose={closVerificateUserModal}
                    style={verificateUserModalStyles}
                    contentLabel="Example Modal2"
                // shouldCloseOnOverlayClick={false}
                >
                    <ModalVerificateUser
                        server={server}
                        onLogin={onLogin}
                        closVerificateUserModal={closVerificateUserModal}
                        languaje={languaje}
                    ></ModalVerificateUser>
                </Modal>
            </AppProvider>
        </div>
    );
};

export default Main;
